/** The root asset is also Pages' SPA fallback for saved application URLs. */
export function websiteEntry(pathname: string): 'games' | 'account' | 'share' | 'marketing' {
    if (/^\/games\/bs(?:\/|$)/.test(pathname)) return 'games';
    if (/^\/(?:account(?:\/|$)|dashboard(?:\/|$)|auth\/(?:login|confirm-email|notice|session-ended)(?:\/|$))/.test(pathname)) return 'account';
    if (/^\/share(?:\/|$)/.test(pathname)) return 'share';
    return 'marketing';
}
